<cj-form-field class="position-relative">
  <cj-icon
    *ngIf="iconPlacement === 'prefix' && icon"
    cjPrefix
    [icon]="icon"
    pack="font-awesome-solid"
  ></cj-icon>
  <cj-icon
    *ngIf="iconPlacement === 'suffix' && icon"
    cjSuffix
    [icon]="icon"
    pack="font-awesome-solid"
  ></cj-icon>
  <input
    cjInput
    [class]="className"
    [id]="id"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [inputMask]="currencyInputMask"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    [ngModelOptions]="{ standalone: true }"
    (blur)="onBlur($event)"
    fullWidth
  />
</cj-form-field>
<!-- For NgForm Input number validation -->
<input
  type="number"
  [min]="min"
  [max]="max"
  [name]="name"
  [required]="required || null"
  [ngModel]="amount"
  hidden
/>
